import { transformDescription } from './description'

/**
 * Transforms attribute information from the Shopware attributes.
 *
 * @example
 * const {description} = transform(...)
 */
export const transform = (description: string) => ({
    description: transformDescription(description),
})
